export const SET_SCREEN_NAME = "SET_SCREEN_NAME";
export const EVENT_NAME = "EVENT_NAME";
export const EVENT_PARAMS = "EVENT_PARAMS";
